import * as PropTypes from "prop-types"
import { I18n } from "react-polyglot-hooks"
import RentingScene from "scenes/RentingScene"
import { useRouter } from "next/router"
import { getPreOwnedCarsData } from "services/webService"
import LoadingScene from "scenes/LoadingScene"
import RentingContextProvider from "scenes/RentingScene/RentingContext"
import common from "../../i18n/es/common"
import car from "../../i18n/es/car"
import renting from "../../i18n/es/renting"
import NotFound from "../404"
import { getFooterLinks } from "../../src/services/seoService"

export default function RentingSeminuevos({ cars, kilometers, durations, brands, provinces, notFound, footerLinks }) {
  const { isFallback } = useRouter()

  if (isFallback)
    return (
      <I18n locale="es" phrases={common}>
        <LoadingScene />
      </I18n>
    )

  if (notFound) return <NotFound />

  return (
    <I18n locale="es" phrases={{ ...common, ...car, ...renting }}>
      <RentingContextProvider
        cars={cars}
        kilometers={kilometers}
        durations={durations}
        brands={brands}
        provinces={provinces}
        page="pre-owned"
        variant="pre-owned"
        footerLinks={footerLinks}>
        <RentingScene />
      </RentingContextProvider>
    </I18n>
  )
}

RentingSeminuevos.defaultProps = {
  footerLinks: [],
  cars: [],
  kilometers: [],
  durations: [],
  brands: {},
  provinces: [],
  notFound: false
}

RentingSeminuevos.propTypes = {
  footerLinks: PropTypes.array,
  cars: PropTypes.array,
  kilometers: PropTypes.array,
  durations: PropTypes.array,
  brands: PropTypes.object,
  provinces: PropTypes.array,
  notFound: PropTypes.bool
}

export async function getStaticProps() {
  try {
    const res = await getPreOwnedCarsData("es")

    if (res.status === 404) return { props: { notFound: true }, revalidate: 300 }

    // Footer Links
    const footerLinksRes = await getFooterLinks()
    const footerLinks = await footerLinksRes.json()

    const data = await res.json()
    const { cars, kms: kilometers, durations, brands, provinces } = data

    return { props: { cars, kilometers, durations, brands, provinces, footerLinks }, revalidate: 300 }
  } catch (error) {
    console.error('Error en getStaticProps de renting-seminuevos:', error);
    return { 
      props: { notFound: true }, 
      revalidate: 60 // Intentar de nuevo en 60 segundos
    };
  }
}
